import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { size as _size, trim as _trim, isEmpty as _isEmpty } from 'lodash';
import { getPlatformName, i18nIntl, isNotEmpty, validateEmail } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import Autocomplete from '../builder/Autocomplete';
import { Checkbox } from '../builder/Checkbox';
import CountryField from '../builder/CountryField';
import DateWithSelector from '../builder/DateWithSelector';
import DisabledArea from '../builder/DisabledArea';
import EmailField from '../builder/EmailField';
import FileUploader from '../builder/FileUploader';
import Input from '../builder/Input';
import MediaPicker from '../builder/MediaPicker';
import Model from '../builder/Model';
import RadioGroup from '../builder/RadioGroup';
import SaveButton from '../builder/SaveButton';
import Select from '../builder/Select';
import TextArea from '../builder/TextArea';
import VideoPicker from '../builder/VideoPicker';

import FloatingLayerPublic from './FloatingLayerPublic';
import { UploadAvatar } from './UserAvatar';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import GoogleRecaptchaComponent from '../builder/GoogleRecaptchaComponent.js';
import { countryValidators } from '../../lib/hooks/country_validators.js';
import SignatureCanvas from '../builder/SignatureCanvas.js';
import PhoneField, { validatePrefixAndPhone } from '../builder/PhoneField.js';
import CheckBoxGroup from '../builder/CheckBoxGroup.js';

/**
 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
 * @author ShirtlessKirk. Copyright (c) 2012.
 * @license WTFPL (http://www.wtfpl.net/txt/copying)
 * Original source: https://gist.github.com/ShirtlessKirk/2134376
 */
const luhnCheck = (function(arr) {
	return (ccNum) => {
		let len = ccNum.length;
		let bit = 1;
		let sum = 0;
		let val;

		while(len) {
			val = parseInt(ccNum.charAt(--len), 10);
			sum += (bit ^= 1) ? arr[val] : val;
		}

		return sum && sum % 10 === 0;
	};
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

const cleanForLuhn = (value) => {
	const searchRegExp = /[\s\-\_\,\.]/g;
	const replaceWith = '';
	value = `${value}`.replace(searchRegExp, replaceWith);
	return luhnCheck(value);
};

class ParticipateForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			display_policy_layer:false,
			display_toc_layer:false,
			errors:(props.errors != undefined) ? props.errors : {},
			first_name:"",
			last_name:"",
			email:"",
			method:null,
			submit_label:props.submit_label,
			submiting:false,
			recaptcha_loaded:false,
			countryValidators:[],
		}

		this.raw_fields = this.props.fields.Promotion;
		this.raw_fields_cf = this.props.fields.CustomFields;
		this.country_id_by_ip = this.props?.country_id ?? false;

		this.max_nickname_length = 50;

		this.form = (props.form != undefined) ? props.form : {};
		if(!this.form['email']) this.form['email']='';

		/*this.raw_fields_cf.map((item, i) => {
			if(item.type == '8' && item.config != undefined) this.form['cf_'+item.id] = item.config.default;
			else if(item.type == '3' && item.preselected == "1") this.form['cf_'+item.id] = true;
		});*/
		this.fields = [];

		this.custom_labels = (this.raw_fields && this.raw_fields.custom_labels != undefined) ? this.raw_fields.custom_labels : {};
		this.vars = this.props.vars != undefined ? this.props.vars : {};

		this.has_recaptcha = this.props?.recaptcha ?? false;
		if(this.has_recaptcha){
			this._reCaptchaRef = React.createRef();
		}
		
		if (this.raw_fields_cf.filter(cf=>(cf.type == '12')).length > 0) {
			countryValidators().then(validators=>{
				this.setState({countryValidators:validators});
			})
		}

	}

	componentWillMount() {
		const disable_last_name = this.props?.promotion?.Promotion?.disable_last_name ?? false;

		this.fields = this.computeFields(false, disable_last_name);
		this.setState({ fields:this.fields, errors:{} });
	}

	resetRecaptcha = () => {
		if(this.has_recaptcha){
			this._reCaptchaRef.current.resetRecaptcha();
			this.form['g-recaptcha-response'] = null;
		}
	}

	componentWillReceiveProps(props) {
		
		this.custom_labels = props?.fields?.Promotion?.custom_labels ?? {};

		const disable_last_name = props?.promotion?.Promotion?.disable_last_name ?? false;

		this.fields = this.computeFields(props, disable_last_name);
		this.setState({ fields:this.fields, submit_label:props.submit_label, errors:props.errors });
		if(Object.keys(props?.errors ?? []).length > 0)this.resetRecaptcha();
	}

	/*validateEmail(passed) {
		if(!passed){
			this.state.errors['email'] = {message:"Wrong email format."};
			this.setState({...this.state});
		}
	}*/

	validatePhone(passed,message) {
		if(!passed){
			this.state.errors['phone'] = message;
			this.setState({...this.state});
		}
	}

	computeFields = (props, disable_last_name) => {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		this.raw_fields = (props !== false) ? props.fields.Promotion : this.props.fields.Promotion;
		this.raw_fields_cf = (props !== false) ? props.fields.CustomFields : this.props.fields.CustomFields;
		
		this.raw_fields_cf.map((item, i) => {
			if(item.type == '8' && item.config != undefined) this.form['cf_'+item.id] = item.config.default;
			else if(item.type == '3' && item.preselected == "1") this.form['cf_'+item.id] = true;
		});

		var fields = [];
		if(this.raw_fields.need_nickname != undefined && this.raw_fields.need_nickname == '1') {
			const disabledNickname = this.props.method == 'twitch' ? true : false;

			const with_avatar = this.raw_fields?.avatar_in_form ?? false;

			if(with_avatar) {
				fields.push({
					key:'avatar',
					label:null,
					ItemType:UploadAvatar,
					field_width:'half',
					props:{
						user:{
							promotion_id:this.raw_fields.id,
							avatar:this.form.avatar,
							full_avatar:this.form.full_avatar
						},
						width:50,
						height:50,
						enable_actions:false,
						_styles:{alignSelf:'flex-end', marginRight:'1.5em', order:'1'},
						_class:'react_field type_avatar field_UserAvatar is_2_columned'
					}
				});
			}

			fields.push({
				key:'nickname',
				label:(this.custom_labels.nickname != undefined && this.custom_labels.nickname != "") ? this.custom_labels.nickname : "Nickname",
				ItemType:Input,
				field_width:(with_avatar) ? 'half' : null,
				props:{
					error_msg_position_class:'mod_align_left',
					min_length:3,
					max_length:this.max_nickname_length,
					disabled:disabledNickname,
					off:disabledNickname,
					_field_style:(with_avatar) ? {flexGrow:'1'} : null,
				}
			});
		}

		if((this.raw_fields.hide_name == undefined || !this.raw_fields.hide_name) && !this.raw_fields.skip_name) {
			const disableName = (this.props.method == 'madrid' && !this.raw_fields.login_token_madrid)

			fields.push({
				key:'first_name',
				label:"First name",
				ItemType:Input,
				field_width:(!disable_last_name) ? 'half' : 'full',
				props:{
					error_msg_position_class:'mod_align_left',
				},
			});

			if(disableName) {
				if(fields[fields.length-1].props == undefined) fields[fields.length-1].props = {};
				fields[fields.length-1].props.disabled = true;
			}

			if(!disable_last_name) {
				fields.push({
					key:'last_name',
					label:"Last name",
					ItemType:Input,
					field_width:'half',
					props:{
						error_msg_position_class:'mod_align_left',
					},
				});
			}

			if(disableName) {
				if(fields[fields.length-1].props == undefined) fields[fields.length-1].props = {};
				fields[fields.length-1].props.disabled = true;
			}
		}

		if(this.raw_fields.need_email != "0") {
			const has_email_validation = ((
				this.raw_fields.login_token && this.props.method == 'email') ||
				(this.raw_fields.login_token_fb && this.props.method == 'facebook') ||
				(this.raw_fields.login_token_google && this.props.method == 'google') ||
				(this.raw_fields.login_token_linkedin && this.props.method == 'linkedin') ||
				(this.raw_fields.login_token_twitch && this.props.method == 'twitch') ||
				(this.raw_fields.login_token_tiktok && this.props.method == 'tiktok')) ? true :false;
			var after_message = null;

			const disableEmail =
				(this.props.method == 'facebook' && !this.raw_fields.login_token_fb) ||
				(this.props.method == 'google' && !this.raw_fields.login_token_google) ||
				(this.props.method == 'linkedin' && !this.raw_fields.login_token_linkedin) ||
				(this.props.method == 'twitch' && !this.raw_fields.login_token_twitch && this.state['email'] != "") ||
				(this.props.method == 'tiktok' && !this.raw_fields.login_token_tiktok && this.state['email'] != "") ||
				(this.props.method == 'madrid' && !this.raw_fields.login_token_madrid)

			// no login
			if(this.raw_fields.email_config != undefined && this.raw_fields.email_config.email_id != undefined && this.raw_fields.email_config.email_id !== false) after_message = (this.custom_labels.email_validation != undefined) ? this.custom_labels.email_validation : i18n("A validation email will be sent to your inbox");

			// login with e-mail validation
			if(has_email_validation) after_message = i18n("You are going to receive an e-mail with an access link to participate.");

			var d = {
				key:'email',
				label:(isNotEmpty(this.custom_labels, 'email_field')) ? this.custom_labels.email_field : "Email",
				ItemType:Input,
				props:{
					after_message:after_message,
					error_msg_position_class:'mod_align_left',
					_type:'email',
				},
			};

			if(this.props.disableEmail != undefined && this.props.disableEmail || disableEmail) {
				d.props.disabled = true;
			}
			const hideEmail = this.props?.hideEmail ?? false;
			if(!hideEmail)fields.push(d);

			if(!hideEmail && this.raw_fields.config != undefined && this.raw_fields.config.verify_email != undefined && this.raw_fields.config.verify_email) {
				fields.push({
					key:'email_verify',
					label:"Verify email",
					ItemType:EmailField,
					props:{
						error_msg_position_class:'mod_align_left',
					},
				});
			}
		}

		if(this.raw_fields.need_phone == '1') {
			const is_multiparticipation = this.raw_fields.multi_participation != undefined ? this.raw_fields.multi_participation : false;
			var d = {
				key:'phone',
				label:(isNotEmpty(this.custom_labels, 'phone_field')) ? this.custom_labels.phone_field : "Phone",
				ItemType:(is_multiparticipation) ? PhoneField : Input,
				props:{
					_type:(is_multiparticipation) ? null : 'tel',
					preferred_countries:(is_multiparticipation) ? this.raw_fields.phone_field_preferred_countries : null,
					avail_countries:(is_multiparticipation) ? this.raw_fields.phone_field_countries : null,
					only_available:false,
					min_digits:this.raw_fields.phone_min_length,
					max_digits:this.raw_fields.phone_max_length,
					error_msg_position_class:'mod_align_left',
					onValidate : (is_valid, name, error) => this.validatePhone(is_valid,error),
					disabled : (this.props.method == 'sms_login' && validatePrefixAndPhone(this.form['phone'])),
					after_message:this.custom_labels.phone_after_message,
					phone_regexp:this.raw_fields.phone_regexp ?? null
				},
			};

			if(this.props.method == 'sms_login') {
				d.props.disabled = true;
			}

			fields.push(d);
		}

		if(this.raw_fields.need_sex == '1') {
			fields.push({
				key:'sex',
				label:"Gender",
				ItemType:Select,
				props:{
					error_msg_position_class:'mod_align_left',
					values:[
						{ k:'', v:"" },
						{ k:'1', v:"Male" },
						{ k:'2', v:"Female" },
					],
				},
			});
		}
		
		if(this.raw_fields.need_birthday == '1') {
			fields.push({
				key:'birthday',
				label:(isNotEmpty(this.custom_labels, 'birthday_field')) ? this.custom_labels.birthday_field : "Birthday",
				ItemType:DateWithSelector,
				props:{
					error_msg_position_class:'mod_align_left',
					min_year:EPGetDateYear(EPDateSubtract('now', 'years', 120)),
					max_year:EPGetDateYear(EPDateSubtract('now', 'years', 13)),
					//min_year:1934,
					//max_year:2011,
				},
			});
		}

		if(this.raw_fields.need_country == '1') {
			fields.push({
				key:'country',
				label:"Country",
				ItemType:CountryField,
				props:{
					error_msg_position_class:'mod_align_left',
					
				},
			});
		}

		if(this.raw_fields.need_city == '1') {
			fields.push({
				key:'city',
				label:"City",
				ItemType:Input,
				props:{
					error_msg_position_class:'mod_align_left',
				},
			});
		}

		if(!_isEmpty(this.raw_fields.need_comments)) {
			fields.push({
				key:'comment',
				label:this.raw_fields.need_comments,
				ItemType:TextArea,
				props:{
					_field_style:{order:51},
					error_msg_position_class:'mod_align_left',
					min_length:this.raw_fields.min_length_comment,
					max_length:this.raw_fields.max_length_comment,
				}
			});
		}

		if(!_isEmpty(this.raw_fields.need_photo) && !_isEmpty(this.raw_fields.need_video)) {
			fields.push({
				key:'media',
				label:this.raw_fields.need_photo,
				ItemType:MediaPicker,
				props:{
					image_props:{
						_accepted_formats:['JPEG', 'PNG', 'GIF'],
						_field_style:{order:50},
						_max_weight:10,//MB
						allowed:'image',
						error_msg_position_class:'mod_align_left',
						dd_size:'full_w',
						onError:(v) => {
							this.state.errors['photo'] = v;
							this.setState({...this.state});
						},
					},
					video_props:{
						error_msg_position_class:'mod_align_left',
						upload_url:'/utils/upload/user_video/'+this.raw_fields.promotion_id
					},
				},
			});
		} else {
			if(!_isEmpty(this.raw_fields.need_photo)) {
				fields.push({
					key:'photo',
					label:this.raw_fields.need_photo,
					ItemType:FileUploader,
					props:{
						_accepted_formats:['JPEG', 'PNG', 'GIF'],
						_field_style:{order:50},
						_max_weight:10,//MB
						allowed:'image',
						error_msg_position_class:'mod_align_left',
						dd_size:'full_w',
						onError:(v) => {
							this.state.errors['photo'] = v;
							this.setState({...this.state});
						},
					},
				});
			}

			if(!_isEmpty(this.raw_fields.need_video)) {
				fields.push({
					key:'video',
					label:this.raw_fields.need_video,
					ItemType:VideoPicker,
					props:{
						_field_style:{order:50},
						error_msg_position_class:'mod_align_left',
						upload_url:'/utils/upload/user_video/'+this.raw_fields.promotion_id
					},
				});
			}
		}

		if(this.raw_fields_cf.length > 0) {
			this.raw_fields_cf.map((cf, i) => {
				// no checkbox / signature custom fields (they will be placed at the bottom of the form)
				if(['3', '13'].includes(cf.type)) return null;
				let values;
				let fetchvalues = (v, cb) => {
					let vs = values.filter((o) => {
						var reg = new RegExp(v.value, 'gi');
						return reg.test(o.k);
					});

					cb(vs.map(v => ({ value:v.k })));

					return vs;
				};

				if(cf.type == '2' || cf.type == '4' || cf.type == '5') {
					values = (cf.type == '14' || (cf?.config?.keyvalue != undefined && cf?.config?.keyvalue == 1))  ? [{ k:" ", v:" " }].concat(cf.options) : [{ k:" ", v:" " }].concat((cf?.options || '').split("\n").map((v) => { return { k:v, v:v }; }));
				}

				if(cf.type == '14') {
					values = cf.options;
				}

				const default_cf_data = {
					key:`cf_${cf.id}`,
					label:cf.title,
					mandatory:(cf.mandatory == '1') ? true : false,
					props:{
						after_message:cf.config?.after_message ?? null,
					},
				};

				switch(cf.type) {
					case '1':

						const _hide_text_as_password = (cf?.config?.hide_text ?? 0) != "0" ? true : false;
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:(cf.size == '0') ? Input : TextArea,
							props:{
								...default_cf_data.props,
								_type:(cf.size == '0' && _hide_text_as_password) ? "password" : "text",
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '2':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:Select,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								values:values,
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;
					case '10':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:CountryField,
							label:cf.title == "" ? i18n("Country") : i18n(cf.title),
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								key:'country',
								_field_style:{order:(cf.pos + 2)},
								default:this.country_id_by_ip,
								include:cf.config?.include ?? "",
								exclude:cf.config?.exclude ?? "",
							},
						}));
						break;

					case '11':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:Select,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								values:[{k:'',v:'---'}].concat((cf?.config?.segments ?? []).map(s=>({
									k:s.segment_id,
									v:(s.label != undefined && s.label != "") ? s.label : s.name
								}))),
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '12':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:Input,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;
					case '14':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:CheckBoxGroup,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								elements:(values != undefined && values != "") ? values.map((e) => ({
									label:e.v,
									value:e.k,
								})) : [],
								error_msg_position_class:'mod_align_left',
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '4':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:RadioGroup,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								default:null,
								elements:values.map((e) => ({
									label:e.v,
									value:e.k,
								})),
								error_msg_position_class:'mod_align_left',
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '5':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:Autocomplete,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								values:values,
								fetch:fetchvalues,
								selected:(v) => this.changeForm("cf_"+cf.id, v.suggestion.value),
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '6':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:DateWithSelector,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								min_year:cf.config.min_year,
								max_year:cf.config.max_year,
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;

					case '7':
						const mimetype = cf.config.mediatype;	//all|text|image|appplication|audio|video
						var accepted_formats = [];
						switch(mimetype) {
							case 'text':
								accepted_formats = ['DOC', 'TXT'];
								break;

							case 'image':
								accepted_formats = ['JPEG', 'PNG', 'GIF', 'WEBP', 'HEIC'];
								break;

							case 'audio':
								accepted_formats = ['MP3'];
								break;

							case 'application':
								accepted_formats = ['PDF'];
								break;

							case 'all':
							default:
								accepted_formats = ['JPEG', 'PNG', 'GIF', 'HEIC', 'MP3', 'PDF', 'DOC', 'TXT'];
								break;
						}
						
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:FileUploader,
							props:{
								...default_cf_data.props,
								allowed:mimetype,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								_max_weight:cf.size,//MB
								dd_size:'full_w',
								_accepted_formats:accepted_formats,
								onError:(v) => {
									this.state.errors["cf_"+cf.id] = v;
									if(!v) delete this.state.errors["cf_"+cf.id];
									this.setState({...this.state});
								},
								_field_style:{order:(cf.pos + 2)},
							},
						}));
						break;
				}
			});
		}

		if(!_isEmpty(this.raw_fields.toc) || !_isEmpty(this.raw_fields.external_toc_url)) {
			if(this.raw_fields.config.hide_toc_check == undefined || this.raw_fields.config.hide_toc_check == 'false') {
				var toc_link = null;
				if(isNotEmpty(this.raw_fields, 'external_toc_url')) {
					toc_link = <ActionLink _href={this.raw_fields.external_toc_url} _target="_blank">Terms and conditions</ActionLink>;
				} else {
					toc_link = <ActionLink onClick={() => this.toggleToc()}>Terms and conditions</ActionLink>;
				}

				if(this.custom_labels.toc_label != undefined) this.custom_labels.toc_label = this.custom_labels.toc_label.replace('%s','{toc}');

				fields.push({
					key:'toc',
					label:<FormattedMessage id={(this.custom_labels.toc_label) ? this.custom_labels.toc_label : "I have read and accept the {toc}."} values={{toc:toc_link}} />,
					ItemType:Checkbox,
					field_type:'checkbox',
					props:{
						error_msg_position_class:'mod_align_left',
						//value:(value == "1" || value == true) ? '1' : '0',
						_field_style:{order:297},
					},
				});
			}
		}

		if(!_isEmpty(this.raw_fields.policy) || !_isEmpty(this.raw_fields.external_policy_url)) {
			if(this.raw_fields.config.hide_policy_check == undefined || this.raw_fields.config.hide_policy_check == 'false') {
				var policy_link = null;
				if(isNotEmpty(this.raw_fields, 'external_policy_url')) {
					policy_link = <ActionLink _href={this.raw_fields.external_policy_url} _target="_blank">Privacy policy</ActionLink>;
				} else {
					policy_link = <ActionLink onClick={() => this.togglePolicy()}>Privacy policy</ActionLink>;
				}

				if(this.custom_labels.policy_label != undefined) this.custom_labels.policy_label = this.custom_labels.policy_label.replace('%s','{policy}');

				fields.push({
					key:'policy',
					label:<FormattedMessage id={(this.custom_labels.policy_label) ? this.custom_labels.policy_label : i18n("***I have read and accept the {policy}.")} values={{policy:policy_link}} />,
					ItemType:Checkbox,
					field_type:'checkbox',
					props:{
						error_msg_position_class:'mod_align_left',
						//value:(value == "1" || value == true) ? '1' : '0',
						_field_style:{order:298},
					},
				});
			}
		}


		if(this.raw_fields_cf.length > 0) {
			this.raw_fields_cf.map((cf, i) => {
				if(!['3', '13'].includes(cf.type)) return null;

				const default_cf_data = {
					key:`cf_${cf.id}`,
					label:cf.title,
					mandatory:(cf.mandatory == '1') ? true : false,
					props:{
						after_message:cf.config?.after_message ?? null,
					},
				};

				switch(cf.type) {
					case '3':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:Checkbox,
							field_type:'checkbox',
							props:{
								...default_cf_data.props,
								autotranslate:false,
								error_msg_position_class:'mod_align_left',
								//value:(value == "1" || value == true) ? '1' : '0',
								_field_style:{order:299},
							},
						}));
						break;

					case '13':
						fields.push(Object.assign({}, {...default_cf_data}, {
							ItemType:SignatureCanvas,
							props:{
								...default_cf_data.props,
								autotranslate:false,
								auto_url:`/users/upload/${this.raw_fields.id}`,
								auto_type:"custom_fields",
								error_msg_position_class:'mod_align_left',
								_field_style:{order:300},
							},
						}));
						break;
				}
			});
		}

		var fields_full = [];
		fields.map((field, f) => {
			fields_full.push(this.ensureOrder(field));
		});

		return fields_full;
	}

	ensureOrder(field) {
		if(field.props == undefined) {
			field.props = {
				_field_style:{
					order:1,
				},
			};
		} else if(field.props._field_style == undefined) {
			field.props._field_style = {
				order:1,
			};
		} else if(field.props._field_style.order == undefined) {
			field.props._field_style.order = 1;
		}

		return field;
	}

	toggleToc() {
		this.setState({ display_toc_layer:!this.state.display_toc_layer });
	}

	togglePolicy() {
		this.setState({ display_policy_layer:!this.state.display_policy_layer });
	}

	setMethod = (m) => {
		this.setState({ method:m });
	}

	change = (k, v) => {
		this.state[k] = v;
		this.setState({...this.state});
	}

	changeForm = (k, v) => {
		if (k == 'full_avatar') return;
		this.form[k] = v;
		this.validate(k, v);
		if (this.raw_fields.need_email != "0") {
			this.validate('email', this.form.email);	// <---- PARCHE
		}
	}

	testReg = (cf, v) => {
		var patt = new RegExp(cf.options, "m");
		var res = patt.test(v);

		return (res) ? true : false;
	}

	testAutoComplete = (cf, v) => {
		var nstr = (cf.options).split(/\n/);
		for(var i = 0; i < nstr.length; i++) {
			if(v.toLowerCase() == nstr[i].toLowerCase()) return true;
		}

		return false;
	}

	validateDocument = (cf, v) => {

		var validators = cf.config?.documents ?? [];
		if(validators.length == 0)return [true,v];
		let valid_document = false;
		
		validators.map((document,i) => {
			if(document){
				const result = this.state.countryValidators[document.country][document.validator].validate(v);
				if(result.isValid)valid_document=result;
			}
		});
		let result = [false,v];
		if(valid_document?.isValid ?? false){
			//AJAX ONE VALUE
			result = [valid_document.isValid,valid_document.compact]
		}
		return result;
	}

	parseFieldClassName(id, counter) {
		var id_new = ['field_User'];

		id = id.replace("cf_", "customField_");

		const id_parts = id.split("_");
		if(counter != undefined) {
			id_parts[0] = "customField";
			id_parts[1] = "" + counter;
		}

		for(var i in id_parts) {
			id_new.push(id_parts[i][0].toUpperCase() + id_parts[i].substring(1));
		}

		return id_new.join("");
	}

	validateAll(onsubmit,cb) {
		onsubmit = onsubmit != undefined ? onsubmit : false;

		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const promo = this.raw_fields;
		const customFields = this.raw_fields_cf;
		const stage = promo.stage != undefined ? promo.stage : 0;
		var fields_to_evaluate = [];

		const toc_disabled = this.raw_fields.config != undefined && this.raw_fields.config.hide_toc_check != undefined && this.raw_fields.config.hide_toc_check != 'false';
		const policy_disabled = this.raw_fields.config != undefined && this.raw_fields.config.hide_policy_check != undefined && this.raw_fields.config.hide_policy_check != 'false';

		const is_multiparticipation = promo.multi_participation != undefined ? promo.multi_participation : false;
		let evaluate_names = is_multiparticipation && promo.hide_name ? false :  true;

		if(evaluate_names && !promo.skip_name) {
			fields_to_evaluate.push('first_name');
			fields_to_evaluate.push('last_name');
		}

		if(promo.need_email != '0') {
			fields_to_evaluate.push('email');
			if(promo.config != undefined && promo.config.verify_email != undefined && promo.config.verify_email) {
				fields_to_evaluate.push('email_verify');
			}
		}

		if(this.props.fields.Promotion?.need_nickname == "1") {
			fields_to_evaluate.push('nickname');
		}

		if(promo.need_phone == '1'){
			fields_to_evaluate.push('phone');
		}

		if(promo.need_sex == '1') fields_to_evaluate.push('sex');
		if(!_isEmpty(promo.need_comments)) fields_to_evaluate.push('comment');
		if(!toc_disabled && (!_isEmpty(promo.toc) || !_isEmpty(promo.external_toc_url)) )  fields_to_evaluate.push('toc');
		if(!policy_disabled &&  (!_isEmpty(promo.policy) || !_isEmpty(promo.external_policy_url))) fields_to_evaluate.push('policy');

		if(promo.need_birthday == '1' ) fields_to_evaluate.push('birthday'); //&& !_isEmpty(promo.min_age)

		if(promo.need_city == '1') fields_to_evaluate.push('city');

		if(promo.need_country == '1') fields_to_evaluate.push('country');

		if(customFields.length > 0) {
			customFields.filter(cf=>(cf.type != "9")).map((cf, i) => {
				if(cf.mandatory == '1' || cf.validation == '1' || cf.validation == '2') fields_to_evaluate.push('cf_' + cf.id);
			});
		}

		var value;
		let _errors = this.state?.errors ?? {};
		fields_to_evaluate.map((field, i) => {
			value = (this.form[field] != undefined) ? this.form[field] : '';
			if(field == 'email') {
				if(!validateEmail(value)) {
					_errors[field] = i18n("This email is not valid.");
					this.setState({errors:_errors});
				}
				return;
			}
			
			if(field == 'phone'){//Nou format
				if(!validatePrefixAndPhone(value,promo.phone_min_length, promo.phone_max_length)){
					_errors[field] = i18n("Invalid phone number");
					this.setState({errors:_errors});
					return;
				}

				if (promo.phone_regexp) {
					const regex = new RegExp(promo.phone_regexp);
					const [junk,just_digits] = value.split('-');
					if (!regex.test(just_digits)) {
						_errors[field] = i18n("Invalid phone number");
					this.setState({errors:_errors});
					}
				}
				return 
			}
		
			this.validate(field, value);
			if (field == 'nickname') {
				if(this.throttleChange != undefined) clearInterval(this.throttleChange);
			}
		});

		if(_size(this.state.errors) == 0) {
			if(cb != undefined) cb();
		} else {
			if(onsubmit)this.resetRecaptcha();
			window.scrollTo(0, 0);
		}
	}

	validateNickname(value) {
		const invalid_chars = [',', ':', '"', "'", ';', '\\', '/', '='];
		const has_invalid = new RegExp('[\\' + invalid_chars.join("\\") + ']');
	
		var valid = true;
		var error = false;
		if(value != '') {
			var length_str = value.trim().length;
			if(length_str < 3 || length_str > this.max_nickname_length) {
				valid = false;
				error = "size";
			} else if(has_invalid.test(value)) {
				valid = false;
				error = "chars";
			}
		}
		return {status:valid?1:0,error:error};
	}
	
	validate (k, v) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const promo = this.raw_fields;
		const customFields = this.raw_fields_cf;

		const disable_last_name = promo?.disable_last_name ?? false;

		if(typeof v === 'string' && !(k == 'last_name' && disable_last_name)) v = _trim(v);

		var is_mandatory = true;
		var has_error = false;
		const k_splitted = k.split('_');

		const stage = promo.stage != undefined ? promo.stage : 0;
		let is_cf = false;
		if(k_splitted[0] == 'cf') {
			const customField = customFields.filter((cf) => cf.stage == stage && cf.id == k_splitted[1])[0];
			is_cf = true;
			if(customField?.mandatory != '1') is_mandatory = false;

			if(is_mandatory) {
				var validate = false;
				if(customField.type == '5') {
					validate = this.testAutoComplete(customField,v);
					if(!validate) has_error = i18n("This value is invalid.");
				} else if(customField.type == '12') {
					let returned_value_is_valid=v;
					[validate,returned_value_is_valid] = this.validateDocument(customField,v);
					if(validate && returned_value_is_valid != v){
						this.changeForm(`cf_${customField.id}`,returned_value_is_valid);//Solapem camp a formulari
					}
					if(!validate) has_error = i18n("This value is invalid.");
				} else if(customField.validation == '2') {
					validate = this.testReg(customField,v);
					if(!validate) has_error = i18n("This value is invalid.");
				} else if(customField.validation == '4') {
					if(v.length != parseInt(customField?.config?.length || '16')) {
						validate = false;
						if(!validate) has_error = i18n("This value is invalid.");
					} else {
						validate = cleanForLuhn(v);
						if(!validate || isNaN(validate)) has_error = i18n("This value is invalid.");
					}
				} else if(customField.validation == '1') {
					var options = customField.options.split("\n");
					options.map((val, key) => {
						if(val == v) {
							validate = true;
							return;
						}
					});
				}
				else if (customField.type == '14') {
					const values = v == "" ? [] : JSON.parse(v);
					
					if (customField.config?.min_selected) {
						if (values.length < customField.config.min_selected) {
							has_error = this.props.intl.formatMessage({ id:"At least {num} options should be selected" }, { num:customField.config.min_selected });
						}
						else if (values.length > customField.config.max_selected) {
							has_error = this.props.intl.formatMessage({ id:"Only {num} options can be selected" }, { num:customField.config.max_selected });
						}
					}
				}

				if(customField.validation > 0 && customField.validation < 3 && !validate) {
					has_error = i18n("This value is invalid.");
				}
			}
		}

		// all fields, except those that have "mandatory = 0" (custom fields), are mandatory:
		const typeof_v = typeof v;
		if(is_mandatory && (typeof_v === 'string' && _size(v) < 1 || typeof_v === 'boolean' && !v) && !has_error) {
			has_error = i18n("This field cannot be left empty");
		}

		switch(k) {
			case 'email':
				/*if(!validateEmail(v)) {
					has_error = i18n("The email format is not correct.");
				}*/
				break;

			case 'email_verify':
				if(v != this.form['email']) has_error = i18n("Both emails must match.");
				break;

			case 'birthday':
				if(promo.min_age != undefined && promo.min_age > 0) {
					const diff_to_now = EPDateDuration(EPDateDiff(null, `${v.year}-${v.month}-${v.day}`)).years();
					if(diff_to_now < promo.min_age) {
						has_error = this.props.intl.formatMessage({id:"The minimum age allowed is {age}"}, { age:promo.min_age });
					}
				}
				break;
			case 'nickname':
				if(v != ''){
					let nickname_result = this.validateNickname(v);
					if(!nickname_result.status) {
						has_error = i18n("The nickname has to have at least three characters.");
					} else {
						this.setState({...this.state});
						if(this.throttleChange != undefined) clearInterval(this.throttleChange);
						this.throttleChange = setTimeout(() => {
							let data = {nickname:v,id:promo.id};
							$.post('/utils/nickname/', data, (result) => {
								if(!result.status){
									this.state.errors[k] = i18n("This nickname is already registered");
								}
								this.setState({...this.state});
							},'JSON');
						}, 500);
					}
				}
				break;
			
		}

		if(this.state.errors != undefined){
			if(has_error !== false) {
				this.state.errors[k] = has_error;
			} else {
				if(this.state.errors[k])delete this.state.errors[k];
			}
		}
		this.setState({...this.state});
	}

	onSubmit = (cb) => {
		this.validateAll(true,() => {
			this.setState({submiting:true});
			if(this.props.onSubmit != undefined){
				this.props.onSubmit(this.form,()=>{
					this.setState({submiting:false});
					if(cb != undefined)cb();
				});
			}
		});
		if(_size(this.state.errors) > 0 && cb != undefined) cb();
	}


	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const submit_label = (this.state.submit_label != undefined && this.state.submit_label != "") ? i18n(this.state.submit_label) : i18n("Submit");

		const in_promotion = (this.props.promotion != undefined) ? true : false;
		var cf_counter = -1;
		const promo = this.props.fields.Promotion;
		const is_test = promo.test ?? false;
		const is_builder = this.props?.is_builder ?? false;
		const recaptcha_key = (!is_test || is_builder) ? "6LelbTQoAAAAAGw3P97Uzp2e2iApinJN--6zNJrw" : "6LcA3gEoAAAAAHYqmuv0-_9OiitVIZbbS_j-8--j";//Promo Test Prod  => NoCheck 1.0
		const generic_toc_link = `https://${window.domain_url}/promo_terms/${promo.id}`;
		//const generic_toc_link = this.public_url + 'promo_terms/' + this.raw_fields.promotion_id;
		const generic_policy_link = `https://${window.domain_url}/policy/${promo.id}`;
		//const generic_policy_link = this.public_url + 'policy/' + this.raw_fields.promotion_id;
		const is_multiparticipation = promo.multi_participation != undefined ? promo.multi_participation : false;
		const display_recaptcha = (this.has_recaptcha && !is_builder || is_builder && promo.recaptcha_validation) && is_multiparticipation;
		return (
			<article>
				<div class="gui_form_register template_module gui_main_text_color_on_bg gui_form">
					<Model
						model={this.form}
						change={(k, v) => this.changeForm(k, v)}
						errors={this.state.errors}
						use_wrapper={false}
					>
						{this.fields.map((field, f) => {
							if(field.field_type != undefined && field.field_type == 'checkbox') return null;

							var counter = null;
							var field_id = null;
							if(field.key.indexOf("cf_") != -1) {
								cf_counter++;
								counter = cf_counter;
								field_id = 'CustomValue' + cf_counter + 'Value';
							}
							var field_classes = [this.parseFieldClassName(field.key, counter)];
							if((field.mandatory == undefined || field.mandatory)) field_classes.push('required');
							switch(field.field_width) {
								case 'third':
									field_classes.push('is_3_columned');
									break;

								case 'half':
									field_classes.push('is_2_columned');
									break;

								case 'full':
								default:
									field_classes.push('is_1_columned');
									break;
							}
							return (
								<field.ItemType
									key={f}
									id={field_id}
									name={field.key}
									_field_class={field_classes.join(" ")}
									error_msg_position_class="only_text"
									{...field.props}
								>{field.label}</field.ItemType>
							)
						})}
					</Model>

					{(promo.disclaimer != undefined && promo.disclaimer != "") && (
						<LeveledHTMLText
							_class={{ other:'legal_text mod_align_left gui_main_text_color_on_bg' }}
							style={{ order:196 }}
							is_text_block={false}
						>{promo.disclaimer}</LeveledHTMLText>
					)}

					<Model
						model={this.form}
						change={(k, v) => this.changeForm(k, v)}
						errors={this.state.errors}
						use_wrapper={false}
					>
						{this.fields.map((field, f) => {
							if(field.field_type == undefined || field.field_type != 'checkbox') return null;

							var counter = null;
							var field_id = null;
							if(field.key.indexOf("cf_") != -1) {
								cf_counter++;
								counter = cf_counter;
								field_id = `CustomValue${cf_counter}Value`;
							}
							var field_classes = [this.parseFieldClassName(field.key, counter)];
							if((field.mandatory == undefined || field.mandatory)) field_classes.push('required');
							switch(field.field_width) {
								case 'third':
									field_classes.push('is_3_columned');
									break;

								case 'half':
									field_classes.push('is_2_columned');
									break;

								case 'full':
								default:
									field_classes.push('is_1_columned');
									break;
							}
							return (
								<field.ItemType
									key={f}
									id={field_id}
									name={field.key}
									_field_class={field_classes.join(" ")}
									error_msg_position_class="only_text"
									{...field.props}
								>{field.label}</field.ItemType>
							)
						})}
					</Model>
				</div>

				{(this.state?.errors?.phone_verification != undefined) && (
					<div>
						{i18n("Phone could not be verified")}: {this.state.errors['phone_verification']}
					</div>
				)}
				

				{(display_recaptcha) && (
					<GoogleRecaptchaComponent
						sitekey =  {recaptcha_key}
						onChange = {(v) => this.changeForm('g-recaptcha-response',v)}
						onLoaded = {(v) => this.setState({recaptcha_loaded:v})}
						ref = {this._reCaptchaRef}
						is_builder = {is_builder}
						action = {`register_${getPlatformName(promo.promo_type,true)}_${promo.id}`}
					/>
				)}
				
				<DisabledArea disabled={(_size(this.state.errors) > 0) ? true : false} message="To submit, please first fix the errors">
					<div class="template_module mod_align_center register_call_to_action_flex is_react_cta">
						<div class={'finalize_form enter flex_button gui_big_button dis_wo_signin' + ((!in_promotion) ? ' blueBg' : '')}>
							<SaveButton
								_fullclass=""
								disabled={(_size(this.state.errors) > 0 || this.state.submiting || (this.has_recaptcha && !this.form['g-recaptcha-response'])) ? true : false}
								onClick={(e, cb) => this.onSubmit(cb)}
								autotranslate={false}
							>{submit_label}</SaveButton>
						</div>
					</div>
				</DisabledArea>
								
				{(in_promotion && this.state.display_toc_layer) && (
					<FloatingLayerPublic
						pm={this.props.promotion.Promotion}
						//title={i18n("Terms and conditions")}
						backButton={() => this.toggleToc()}
					>
						<div dangerouslySetInnerHTML={{ __html:this.props.promotion.Promotion.toc.replace(/\n/g, '<br />') }}></div>
						<ul class="related_link original_color_item">
							<li class="link"><ActionLink _href={generic_toc_link} _target="_blank" _class={{other:'toc_link'}} autotranslate={false}>{generic_toc_link}</ActionLink></li>
						</ul>
					</FloatingLayerPublic>
				)}

				{(in_promotion && this.state.display_policy_layer) && (
					<FloatingLayerPublic
						pm={this.props.promotion.Promotion}
						//title={i18n("Privacy policy")}
						backButton={() => this.togglePolicy()}
					>
						<div dangerouslySetInnerHTML={{ __html:this.props.promotion.Promotion.policy.replace(/\n/g, '<br />') }}></div>

						<ul class="related_link original_color_item">
							<li class="link"><ActionLink _href={generic_policy_link} _target="_blank" _class={{other:'toc_link'}} autotranslate={false}>{generic_policy_link}</ActionLink></li>
						</ul>
					</FloatingLayerPublic>
				)}
			</article>
		)
	}
}

export default (injectIntl(ParticipateForm));